"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSAccountInformationComponent = void 0;
const core_1 = require("@angular/core");
const account_service_1 = require("../../services/account.service");
const accountsettings_service_1 = require("../../services/accountsettings.service");
const contactinformation_component_1 = require("../contactinformation/contactinformation.component");
const generic_content_service_1 = require("../../../shared/services/generic.content.service");
const roles_helper_service_1 = require("../../services/roles-helper.service");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const lodash_1 = require("lodash");
const router_1 = require("@angular/router");
const generic_content_service_2 = require("../../services/generic-content.service");
const constants_1 = require("../../constants");
class CSAccountInformationComponent extends contactinformation_component_1.CSContactInformationComponent {
    constructor(accountDetailService, accountService, modalService, genericContentService, genericContentServiceV2, rolesService, router) {
        super(accountDetailService, accountService, genericContentService, rolesService);
        this.modalService = modalService;
        this.genericContentServiceV2 = genericContentServiceV2;
        this.router = router;
        this.stateList = [
            { name: 'Alabama', value: 'AL' },
            { name: 'Arkansas', value: 'AR' },
            { name: 'Florida', value: 'FL' },
            { name: 'Mississippi', value: 'MS' },
            { name: 'Tennessee', value: 'TN' }
        ];
        this.roles = constants_1.UserRole;
    }
    ngOnInit() {
        this.verifyMyAccountButton = '<button type="button" class="btn py-2 btn-outline-primary" role="button">Verify My Account Now</button>';
        this.getAccountDetails();
        this.showForm = true;
        this.getErrorMessage();
        this.isSecondary = (localStorage.getItem('profileType') === 'SECONDARY');
        this.getGenericContent();
    }
    getAccountDetails() {
        super.getAccountInformationDetails();
    }
    submitAccountInfo(value) {
        super.submitContactInformation(value);
    }
    updateUserIdInfo(value) {
        // Only if the button is clicked will the new user Id be reflected above the "new user id" and "re enter user id"
        if (super.getErrorMessage() === null) {
            this.contactInfo.loginId = this.userNewId;
        }
        super.updateUserIdInformation(value);
    }
    getErrorMessage() {
        super.getErrorMessage();
    }
    showRoles(roles) {
        return this.rolesService.getRolesPermission(roles, true);
    }
    showEmailVerification() {
        this.open(this.verifyEmailContent);
    }
    open(content, options = { windowClass: 'dark-modal', centered: true }) {
        this.modelRef = this.modalService.open(content, options);
    }
    verifyEmailAddress(content) {
        this.pageLoader = true;
        this.accountService.sendVerifyEmailLink(content).subscribe((data) => {
            if (data.success === true) {
                this.pageLoader = false;
                this.sentVerificationEmail = true;
            }
        }, (err) => {
            this.error = err;
            this.pageLoader = false;
        });
    }
    navigate() {
        if (this.isBusinessAccount) {
            location.href = '/my_account/personal/#/business/account-settings';
        }
        else {
            location.href = '/my_account/personal/#/wireless/account-settings';
        }
        this.modelRef.close();
    }
    cancelAccountInfo() {
        this.tempContactInfo = lodash_1.cloneDeep(this.contactInfo);
        if (this.showForm === true) {
            this.contactInfo = this.tempContactInfo;
        }
    }
    onSubmitValidateCPNI(value) {
        this.personalInfoFormData = value;
        if (this.cpinRequired) {
            if (this.personalInfoFormData.email !== this.emailAddress) {
                this.openPopupModal(this.cpniModelContent);
            }
            else {
                this.submitAccountInfo(this.personalInfoFormData);
            }
        }
        else {
            this.submitAccountInfo(this.personalInfoFormData);
        }
    }
    verifyandSubmit(action) {
        this.modelRef.close();
        if (action === 'verify') {
            this.router.navigate(['/wireless/billing']);
        }
        else {
            this.submitAccountInfo(this.personalInfoFormData);
        }
    }
    openPopupModal(content, options = { size: 'lg', windowClass: 'dark-modal', centered: true }) {
        this.modelRef = this.modalService.open(content, options);
    }
    getGenericContent() {
        const genericContentIds = [
            'genericCpniValidationWarning'
        ];
        this.genericContentServiceV2.getBulkGenericContent(genericContentIds).subscribe((bulkGenericContent) => {
            for (const genericContent of bulkGenericContent) {
                switch (genericContent.id) {
                    case 'genericCpniValidationWarning':
                        this.genericCpniValidationWarning = genericContent.content;
                        break;
                    default:
                        break;
                }
            }
        }, (error) => { });
    }
}
exports.CSAccountInformationComponent = CSAccountInformationComponent;
//# sourceMappingURL=accountinformation.component.js.map